import axios, { AxiosInstance } from "axios";

const axiosRequest: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN,
  headers: {
    //
  },
});

export default axiosRequest;
